import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, ServicioFormatoAsistencialService, HistoriaDiagnostico, FiltrosFormatoAsistencialEntity, DatoEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-tabla-dx',
  templateUrl: './tabla-dx.component.html',
  styleUrls: ['./tabla-dx.component.css']
})
export class TablaDxComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  historiaDiagnosticos: HistoriaDiagnostico[] = [];
  hijos: NodoEntity[] = [];
  datos: DatoEntity[] = [];
  data: { code: string, descripcion: string, pos: number}[] = [];

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.hijos = this.nodo.hijos;
    this.datos = this.nodo.datos;
    if (this.hijos && this.hijos.length > 0) {
      this.getHistoriaDiagnosticos(this.filtros.codigoBaseDatos, this.filtros.tta);
    } else {
      this.data = [];
    }
  }

  async getHistoriaDiagnosticos(db: string, tta: number) {
    try {
      const response = await this.servicioFormato.getHistoriaDiagnosticos(db, tta);
      if (response != null) {
        response.subscribe((data: HistoriaDiagnostico[]) => {
          this.historiaDiagnosticos = data;          
          this.generateData();
        }, (err: HttpErrorResponse) => {
          this.historiaDiagnosticos = [];
          console.error('Error Lista Diagnosticos', err);
        })
      }
    } catch (e) {
      this.historiaDiagnosticos = [];
      console.error('Catch Lista Diagnosticos', e);
    }
  }

  // Generar la data adecuada
  async generateData() {
    let pos = 0;
    const data: { code: string, descripcion: string, pos: number}[] = [];
    if(this.hijos && this.hijos.length > 0 && this.historiaDiagnosticos && this.historiaDiagnosticos.length > 0) {
      this.hijos.forEach((h: NodoEntity) => {
        const dataHijos: DatoEntity[] = this.datos.filter((d: DatoEntity) => {
          return d.idNodoPrincipal === h.padreNodo && d.idNodoRelacionado1 == h.id;
        });

        if (dataHijos && dataHijos.length > 0) {
          dataHijos.forEach((d: DatoEntity) => {
            const value = this.getValueDato(d.valor);
            if (value) {
              const dx = this.getValueData(value);
              if(dx && dx.length > 0) {
                data.push({ code : String(h.id), descripcion : dx, pos : pos});
                pos++;
              }
            }
          })
        }

      })
    }
    this.data = data;
  }

  // Limpiar dato
  getValueDato(value: string) {
    let config = value;
    config = config.replace('id', '');
      config = config.replace('{', '');
      config = config.replace('}', '');
      config = config.replace(':', '');
      config = config.replace(/["']/g, '');
      config = config.replace(/,/g, '');
    return config;
  }

  // Obtener descripción del valor
  getValueData(id: string): string{
    try {
      const unco = Number(id);
      if (unco > 0) {
        const h = this.historiaDiagnosticos.find((dx: HistoriaDiagnostico) => dx.diagnostico.unco === unco);
        return h ? `${h.diagnostico.codigoDiagnostico} - ${h.diagnostico.descripcion}` : '';
      }
    } catch (e) {
    }
    return '';
  }

  getValueColumn(h: NodoEntity, pos: number): string {
    if(this.data && this.data.length > 0) {
      const data = this.data.find((d: { code: string, descripcion: string, pos: number}) => {
        return d.code === String(h.id) && d.pos === pos;
      })
      return data ? data.descripcion : '';
    }
    return '';
  }

}
